module.exports = __webpack_public_path__ + "static/media/img03.b9ed6570.svg";